import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { RegexConstants } from '@wz-constants';
import { HealthModels, QuotationModels, Tarif } from '@wz-models';
import { FileService, LoggerService } from '@wz-services';
import { formatDate } from '@wz-utilities/date.utilities';
import * as CryptoJS from 'crypto-js';
import { ComplementaireSanteService } from 'libs/modules/tunnelsante/services/api/complementaire-sante-api.service';
import { SouscriptionEnLigneApiService } from 'libs/modules/tunnelsante/services/api/souscription-en-ligne-api.service';
import { DocumentTabService } from 'libs/modules/tunnelsante/services/document-tab.service';
import { HttpModels } from 'models/api/http.models';
import { Enfant } from '../../insurances/devis-formulaire/Models/Enfant';
import { NiveauRemboursement } from '../../insurances/devis-formulaire/Models/NiveauRemboursement';
import { Personne } from '../../insurances/devis-formulaire/Models/Personne';
import { Question } from '../../insurances/health-quotation-formB2C/factory-age-validators';
import { TaggingService } from '../../insurances/services/tagging.service';
import { Assurees } from '../models/Assurees.model';
import { FicheComplementaireSante } from '../models/FicheComplementaireSante.model';
import { Paiement } from '../models/Paiement.model';
import {
  Declarations,
  DetailsCotisations,
} from '../models/Recapitulatif.model';
import { Signature } from '../models/Signature.model';
import { Souscription } from '../models/Souscription.model';
import {
  DisplayValues,
  TarifViewModel,
} from '../models/tarif-view-model.model';
import { OriginThemeService } from '../originThemeService';
import { BulletinAdhesionDialogComponent } from './modals/bulletin-adhesion-dialog/bulletin-adhesion-dialog.component';

@Component({
  selector: 'wz-souscription-recap-signature',
  templateUrl: './souscription-recap-signature.component.html',
  styleUrls: ['./souscription-recap-signature.component.scss'],
  standalone: false,
})
export class SouscriptionRecapSignatureComponent implements OnInit {
  @Input()
  public personne!: Personne;
  @Input()
  enfant: Enfant = new Enfant(0, []);
  @Input()
  niveauRemboursement: NiveauRemboursement = new NiveauRemboursement(
    '',
    '',
    '',
    '',
    '',
  );
  defaultcontrolListeParam!: Question[];
  @Input() tarif!: Tarif | any;
  paiement!: Paiement;
  tarifModel!: TarifViewModel;
  nomEtablissement: string = '';
  souscription!: Souscription;
  ficheComplementaireSante!: FicheComplementaireSante;
  assurees!: Assurees;
  iban: string = '';
  bic: string = '';
  regelement: string = '';
  addresse: string = '';
  loiMadelin: string = '';
  // numSS: string = "dfgfdgdfgdfg";
  // contratSanteOuMutuelle : boolean;
  formatDateDebutContrat!: string | null;
  formatDateNaissanceAssure!: string | null;
  formatDateNaissanceMin!: string | null;
  formatDateNaissanceMax!: string | null;
  formatDateEffetMin!: string | null;
  formatDateEffetMax!: string | null;
  DateNaissanceMin!: Date;
  data_value!: HealthModels.HealthQuotationStoredData;
  displayM: boolean = false;
  @Output() inFosPersonneEvent = new EventEmitter();
  @Input() GUID: string = '';
  @Input() MDP: string = '';
  @Output() retourEvent = new EventEmitter();
  valueDisplay!: DisplayValues | any;
  recapValue!: string;
  //Mat Tab index:
  @Input() selectedIndex: number = 0;

  code!: string;
  erreurSignature!: string;
  public sign!: Signature;
  noPortable: boolean = false;

  condition0: boolean = false;
  condition1: boolean = false;
  condition2: boolean = false;
  condition3: boolean = false;
  condition4: boolean = false;
  condition5: boolean = false;
  condition6: boolean = false;
  je_reconnais_clicked: boolean = false;

  doc!: string;
  iframe!: any;
  codeOrganisme!: string;
  @Input() generatePdf: boolean = false;

  loading: boolean = false;

  formulaireFormGroup!: FormGroup;
  codeCtrl!: FormControl;
  //Tagging
  VisiteurId!: string;
  lead_temp: any;

  codeInvalid: any = {
    status: '',
    message: '',
  };

  docName: QuotationModels.DocLink | any = {
    CG: QuotationModels.DocType.CG, //Conditions Génerale,
    FID: QuotationModels.DocType.FID, //Fiche d'Informations Produits,
    TG: QuotationModels.DocType.TG, //Tableau de Garantie
    AnnexeVAD: QuotationModels.DocType.AnnexeVAD, //Annexe sur le droit de rénonciation
    FraisGestion: QuotationModels.DocType.FraisGestion,
  };

  constructor(
    public dialogRef: MatDialog,
    private souscriptionApi: SouscriptionEnLigneApiService,
    private complementaireSanteApi: ComplementaireSanteService,
    private taggingService: TaggingService,
    private dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private router: Router,
    private formBuilder: FormBuilder,
    private originThemeService: OriginThemeService,
    private loggerService: LoggerService,
    private fileService: FileService,
    private documentTabService: DocumentTabService,
  ) {
    this.codeCtrl = this.formBuilder.control('', [
      Validators.required,
      Validators.pattern(RegexConstants.CodeSignature),
    ]);

    this.formulaireFormGroup = new FormGroup({
      // form control fixed here
      codeCtrl: this.codeCtrl,
    });

    this.codeInvalid = {
      status: '',
      message: '',
    };
  }

  ngOnInit() {
    this.themeParams();

    this.personne = new Personne(
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      this.enfant,
      '',
      this.niveauRemboursement,
      '',
      '',
      '',
      false,
    );
    const value = sessionStorage.getItem('app.personne');

    if (value) {
      this.personne = JSON.parse(value);
    }
    const valueTarif = sessionStorage.getItem('app.produittarif');
    if (valueTarif) {
      this.tarif = JSON.parse(valueTarif);
    }

    const getValueDisplay = sessionStorage.getItem('save.valueDisplay');
    if (getValueDisplay) {
      this.valueDisplay = JSON.parse(getValueDisplay);
      this.getCodeOrganisme(this.valueDisplay.assurees.assurePrincipal.orga);
    }

    const adhessionPaiement = sessionStorage.getItem('save.adhesionPaiement');
    if (adhessionPaiement) {
      this.paiement = JSON.parse(adhessionPaiement);
    }
    const getItemSouscription = sessionStorage.getItem('save.souscription');
    if (getItemSouscription) {
      this.souscription = JSON.parse(getItemSouscription);
    }
    const adhessionTarifviewModel = sessionStorage.getItem(
      'save.adhesiontarifviewmodel',
    );
    if (adhessionTarifviewModel) {
      this.tarifModel = JSON.parse(adhessionTarifviewModel);
    }
    const assurePrincipal = sessionStorage.getItem('save.assuree');
    if (assurePrincipal) {
      this.assurees = JSON.parse(assurePrincipal);
    }

    const lead = sessionStorage.getItem('app.lead');
    if (lead) {
      this.lead_temp = JSON.parse(lead);
    } else this.lead_temp = 'comparateurs';

    this.formatDateDebutContrat = formatDate(
      new Date(this.personne.dateDebutContrat),
      'dd-MM-yyyy',
    );
    this.formatDateDebutContrat = formatDate(
      new Date(this.personne.dateDebutContrat),
      'dd-MM-yyyy',
    );
    this.formatDateNaissanceAssure = formatDate(
      new Date(this.personne.dateNaissanceAssure),
      'dd-MM-yyyy',
    );
    this.formatDateNaissanceMin = formatDate(
      this.DateNaissanceMin,
      'yyyy-MM-dd',
    );
  }

  ngOnChanges() {
    if (this.generatePdf && this.selectedIndex == 2) {
      this.generateDoc();

      //Details des cotisations
      this.getDetailsCotisation(
        this.tarif.produitTarif,
        this.tarif.codeFormule,
      );
    }
    //Tagging
    this.VisiteurId = this.taggingService.checkVisiteurId();

    if (
      window['tc_vars'] &&
      window['tC'] &&
      this.VisiteurId != undefined &&
      this.selectedIndex == 2
    ) {
      const sha256Mail = CryptoJS.SHA256(this.personne.email).toString(
        CryptoJS.enc.Hex,
      );
      this.taggingService.refreshSouscription(
        '3',
        'recapitulatif et signature',
        this.VisiteurId,
        sha256Mail,
        this.lead_temp,
        this.tarif,
      );
    }

    //Cacher une partie de l'IBAN
    const iban = this.valueDisplay?.paiement?.iban;
    if (!!this.valueDisplay && !!this.valueDisplay.paiement)
      this.valueDisplay.paiement.iban = this.cacherIban(iban);
  }

  cacherIban(iban: any) {
    if (!iban) return iban;
    const parts = iban.split(' ');
    for (let i = 3; i < parts.length; i++) {
      parts[i] = '****';
    }
    return parts.join(' ');
  }

  getCodeOrganisme(organisme: any): string {
    if (!!organisme && organisme.trim() != '') {
      return ': ' + organisme;
    } else {
      return ' ?';
    }
  }

  onConfirmeSiganture(event: any) {
    if (
      this.condition1 &&
      this.condition2 &&
      this.condition3 &&
      this.condition4 &&
      this.condition6
    ) {
      this.condition0 = true;
    } else {
      this.condition0 = false;
    }
  }

  enableLoading() {
    this.loading = true;
    (document.body as any).style.cursor = 'wait';
  }

  desableLoading() {
    this.loading = false;
    (document.body as any).style.cursor = 'auto';
  }

  AdhesionDocResponse!: any;
  generateDoc() {
    this.souscriptionApi.GetAdhesionDoc().subscribe(
      (rep) => {
        this.AdhesionDocResponse = rep;
        this.doc = 'data:application/pdf;base64,' + rep;
        const iframeElem = document.getElementById('ifrm');
        if (iframeElem) {
          iframeElem.setAttribute('src', this.doc);
        }
      },
      (error) => {
        this.loggerService.log('Erreur Get Document : ' + error);
      },
    );
  }

  onClickDownloadPdf() {
    const linkSource = this.doc;
    const downloadLink = document.createElement('a');
    const fileName = 'bulletin_Adhesion.pdf';
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  //Transform URL to make it works on iframe
  transform(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  ate(a: string) {
    a = a.replace(',', '.');
    const r: number = +a;
    return r;
  }
  formatDateAssure(dateString: Date) {
    formatDate(new Date(dateString), 'dd-MM-yyyy');
  }
  Civilite(sexe: any) {
    switch (sexe) {
      case '1':
        return 'Mme';
      case '2':
        return 'Mr';
      default:
        return 'Mr';
    }
  }
  CiviliteEnfant(sexe: any) {
    switch (sexe) {
      case '1':
        return 'Mlle';
      case '2':
        return 'Mr';
      default:
        return 'Mr';
    }
  }
  RegimeSocial(regime: any) {
    switch (regime) {
      case '0':
        return 'Régime général';
      case '1':
        return 'Travailleur non salarié';
      case '2':
        return 'Sécurité sociale agricole';
      case '3':
        return 'Alsace-moselle';
      default:
        return 'Régime général';
    }
  }
  infosModalAssure() {
    if (this.personne.email != null) {
      sessionStorage.setItem('app.personne', JSON.stringify(this.personne));
      this.displayM = true;
    }
  }

  setQuestionValue(keyString: any, valeur: any) {
    const find_object: any = this.defaultcontrolListeParam.find(
      (x) => x.KeyQ == keyString,
    );

    if (keyString == 'EnfantsDateNaissance') {
      find_object.QuestionValue += valeur + ';';
    } else {
      find_object.QuestionValue = valeur;
    }
  }
  closePopup() {
    this.dialogRef.closeAll();
    this.displayM = false;
  }

  getDateInstance(dateString: string) {
    if (dateString) return new Date(dateString);
    return null;
  }

  retour() {
    if (this.selectedIndex > -2) {
      this.selectedIndex -= 1;
      //Send the selected index to the parent component
      this.retourEvent.emit(this.selectedIndex);
    }
  }
  retourUpdate() {
    if (this.selectedIndex > -2) {
      this.selectedIndex -= 2;
      //Send the selected index to the parent component
      this.retourEvent.emit(this.selectedIndex);
    }
  }
  retourContrat() {
    if (this.selectedIndex > -1) {
      this.selectedIndex -= 1;
      //Send the selected index to the parent component
      this.retourEvent.emit(this.selectedIndex);
    }
  }

  onClickJeReconnais() {
    this.je_reconnais_clicked = true;
  }

  toutChecker(event: any) {
    this.condition1 = this.condition0;
    this.condition2 = this.condition0;
    this.condition3 = this.condition0;
    this.condition4 = this.condition0;
    this.condition6 = this.condition0;

    if (this.je_reconnais_clicked) {
      this.je_reconnais_clicked = false;
    }
  }
  async callPayment() {
    this.router.navigateByUrl('/souscription-paiement');
  }
  async signatureSubscribe() {
    sessionStorage.removeItem('app.fromPage2');
    this.router.navigateByUrl('/souscription-signature');
  }
  async signerContrat(action: any) {
    this.enableLoading();
    if (action == 'signer') {
      this.ficheComplementaireSante = {
        cs_bAcceptCom: this.condition5,
      };
      await this.complementaireSanteApi
        .setFicheCompementaireSante(this.ficheComplementaireSante)
        .toPromise()
        .then((response) => response)
        .catch((error) => console.error(error));
      const signerContratElem = document.getElementById('SignerContrat');
      if (signerContratElem) {
        signerContratElem.style.display = 'none';
      }
      const signElectroElem = document.getElementById('SignElectro');
      if (signElectroElem) {
        signElectroElem.style.display = 'block';
      }
    }
    if (action == 'recevoirCode') {
      if (window['tc_vars'] && window['tC']) {
        if (this.noPortable) {
          window['tC'].event.clic(this, {
            event_id: 'clic',
            event_categorie: 'clic signature',
            event_nom: 'recevoir mon code email',
            event_detail_1: 'cta',
          });
        } else {
          window['tC'].event.clic(this, {
            event_id: 'clic',
            event_categorie: 'clic signature',
            event_nom: 'recevoir mon code sms',
            event_detail_1: 'cta',
          });
        }
      }
      this.sign = new Signature(
        this.personne.nom,
        this.personne.prenom,
        this.personne.telephone,
        this.personne.email,
        this.noPortable,
        false,
        false,
        this.code,
        false,
        '',
        false,
      );
      this.souscriptionApi.GetCodeSignature(this.sign).subscribe(
        (rep) => {
          if (rep != '') {
            this.loggerService.log('Erreur Get Code : ' + rep);
          }
        },
        (error) => {
          this.loggerService.log('Erreur Get Code : ' + error);
        },
      );
      const signElectroElem = document.getElementById('SignElectro');
      if (signElectroElem) {
        signElectroElem.style.display = 'none';
      }
      const signElectro2Elem = document.getElementById('SignElectro2');
      if (signElectro2Elem) {
        signElectro2Elem.style.display = 'block';
      }
    }

    if (action == 'verifierCode') {
      this.sign = new Signature(
        this.personne.nom,
        this.personne.prenom,
        this.personne.telephone,
        this.personne.email,
        this.noPortable,
        true,
        true,
        this.code,
        false,
        '',
        false,
      );
      this.enableLoading();

      //

      const rep = await this.souscriptionApi
        .VerifierCodeSignature(this.sign)
        .toPromise()
        .catch((error) => console.error(error));

      // if (rep && !rep.includes('Erreur')) {

      this.loggerService.log('Vérification code : ' + rep);
      this.erreurSignature = rep;

      // get pdf

      const resp = await this.souscriptionApi
        .getAdhesionDocumentSignature()
        .toPromise()
        .catch((error) => console.error(error));
      if (!resp) {
        // this.interactionService.showError('Code siganture non valide', 'Vous avez entré un code invalide, veuillez consulter votre télephone ou mail');
        this.codeInvalid = {
          status: 'invalide',
          message:
            'Vous avez entré un code invalide, veuillez consulter votre télephone ou mail',
        };
        this.desableLoading();
        return false;
      }

      await this.signatureSubscribe();

      this.codeInvalid = {
        status: '',
        message: '',
      };

      // this.desableLoading();
    }

    this.desableLoading();
    return true;
  }

  //Open Modal Bulletin Adhesion:
  //url test:
  url: string =
    'https://therichpost.com/sample.pdf#toolbar=0&navpanes=0&scrollbar=0';
  showBulletinAdhesionDialog() {
    const dialogRef = this.dialog.open(BulletinAdhesionDialogComponent, {
      width: '75%',
      height: '90vh',
      maxWidth: '90%',
      data: { src: this.doc, title: "Votre bulletin d'adhésion" },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.loggerService.log("Bulletin d'adhésion fermé.");
    });
  }

  //********Déclaration************
  declaration: Declarations | any = {
    content: 'Je déclare : ',
    checked: false,
    subDeclarations: [
      {
        content:
          " <strong>Accepter d'adhérer à l'APSAP</strong> (Association pour la Protection Santé Accident Prévoyance)",
        checked: false,
      },
      {
        content:
          " Avoir été informé que je bénéficie d'un <strong>délai de rétractation de 14 jours calendaires</strong> révolus à compter du jour de la conclusion du contrat",
        checked: false,
      },
      {
        content:
          " Avoir <strong>répondu de manière complète, exacte et sincère aux questions préalables à mon adhésion</strong> et reconnait être informé que toute réticence ou fausse déclaration intentionnelle de ma part pourra entrainer l'application des sanctions prévues aux articles L113-8 et L113-9 du Code des Assurances ou L221-14 et L221-15 du code de la mutualité.",
        checked: false,
      },
      {
        content:
          ' Les <strong>conseils reçus ont revêtu un caractère personnalisé</strong>, adapté à ma situation ainsi qu’à l’assurance de mes risques.',
        checked: false,
      },
      {
        content:
          " Avoir <strong>reçu une information claire et compréhensible</strong> quant à l'étendue et la définition des risques assurés, des garanties proposées et en accepter l'intégralités des termes.",
        checked: false,
      },
      {
        content:
          " Avoir été informé(e) que <strong>mon adhésion est conclue pour une durée annuelle.</strong> Elle est reconduite d'année en année par tacite reconduction sauf dénonciation de mon adhésion par moi ou l'assureur dans les conditions prévues dans les conditions générales valant notice d'information.",
        checked: false,
      },
      {
        content:
          " <strong>Demander expressément l'exécution immédiate et intégrale du contrat</strong> à compter de sa conclusion ou de sa date d’effet, le contrat étant souscrit dans le cadre d'un système de commercialisation à distance.",
        checked: false,
      },
      {
        content:
          " <strong>Accepter que toute information et tout document se rapportant à mon adhésion puisse être communiquée</strong> sur mon espace assuré et que la communication d'informations et de documents par voie électronique est adaptée à ma situation.",
        checked: false,
      },
    ],
  };

  allDeclarationChecked: boolean = false;

  updateAllDeclaration() {
    this.allDeclarationChecked =
      this.declaration.subDeclarations != null &&
      this.declaration.subDeclarations.every((x: any) => x.checked);
  }

  someDeclarationChecked(): boolean {
    if (this.declaration.subDeclarations == null) {
      return false;
    }
    return (
      this.declaration.subDeclarations.filter((x: any) => x.checked).length >
        0 && !this.allDeclarationChecked
    );
  }

  setAllDeclarationChecked(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    this.allDeclarationChecked = checked;
    if (this.declaration.subDeclarations == null) {
      return;
    }
    //Checker toutes les sous déclarations
    this.declaration.subDeclarations.forEach((d: any) => (d.checked = checked));
  }

  // Origine theme

  origine!: string | null;
  originTheme: any;

  c_base = '#6D3311';
  btn_bg!: string;
  avatar = 'souscription/avatar.svg';
  location = 'souscription/location.svg';
  pousette = 'souscription/pousette.svg';
  mail_small = 'souscription/mail_small.svg';
  phone = 'souscription/phone.svg';
  parapluie = 'souscription/parapluie.svg';

  themeParams() {
    const origine: string | null = localStorage.getItem('codeOrigin');
    this.origine =
      origine && this.originThemeService.IsTrueOrigine(origine)
        ? origine
        : null;
    this.originTheme = this.originThemeService.GetTheme(this.origine, 3);
    if (this.origine) this.useTheme(this.originTheme);
  }

  useTheme(theme: any) {
    this.c_base = theme.c_base;
    this.btn_bg = theme.btn_bg;
    this.avatar = theme.avatar;
    this.location = theme.location;
    this.pousette = theme.pousette;
    this.mail_small = theme.mail_small;
    this.phone = theme.phone;
    this.parapluie = theme.parapluie;
  }

  rootDocPath: string = `${window.location.origin}/assets/doc/`;

  getDoc(gammeName: string, docName: string): void {
    const newTab = this.documentTabService.openLoadingTab();

    this.fileService.downloadDocByGammeName(gammeName, docName).subscribe({
      next: (res: HttpModels.HttpFileResponse) => {
        const blob = new Blob([res.blob], { type: 'application/pdf' });
        const blobUrl = URL.createObjectURL(blob);
        this.documentTabService.redirectToBlob(newTab, blobUrl);
      },
      error: (error) => {
        console.error('Erreur lors du téléchargement du document :', error);
        this.documentTabService.showError(newTab);
      },
    });
  }

  cotisationAPSAP: string | any = '';
  fraisFractionnement: string | any = '';
  cotisationAssuresZenioo: string | any = '3';
  fraisDeDossier: string | any = '';
  statusAPSAP: string | any = '';
  textCotisationAPSAP: string | any = '';

  detailsCotisations: DetailsCotisations[] = [];

  //Frais fractionnement et details cotisation
  getDetailsCotisation(codeGamme: string, codeFormule: string) {
    this.detailsCotisations = [];

    const self = this;
    this.souscriptionApi
      .getDetailsCotisation(codeGamme, codeFormule)
      .subscribe({
        next: (response) => {
          if (response && response.length > 0) {
            response.forEach((element: any) => {
              self.detailsCotisations.push({
                NomCritere: element.nomCritere,
                NomGamme: element.nomGamme,
                CodeGamme: element.codeGamme,
                NomFormule: element.nomFormule,
                Montant: element.montant,
                FraisDeDossier: element.fraisDeDossier,
                FileUrlApsap: element.fileUrlApsap,
              });
            });

            self.detailsCotisations.forEach((element) => {
              if (element.NomCritere) {
                if (
                  element.NomCritere.includes('Cotisation annuelle APSAP') ||
                  element.NomCritere.includes('APSAP') ||
                  element.NomCritere.includes('ANASAP')
                ) {
                  self.cotisationAPSAP = element.Montant;

                  const nomCritere = element.NomCritere;
                  if (nomCritere.includes('ANP'))
                    self.textCotisationAPSAP = 'Cotisation ANP';
                  else if (nomCritere.includes('ANASAP'))
                    self.textCotisationAPSAP = 'Cotisation ANASAP';
                  else self.textCotisationAPSAP = 'Cotisation APSAP';
                } else if (
                  element.NomCritere.includes('Frais de fractionnement')
                )
                  self.fraisFractionnement = element.Montant;
              }
            });

            //Frais de dossier
            self.fraisDeDossier = self.detailsCotisations[0].FraisDeDossier;

            //Dynamiser texte APSAP ou ANASAP
            const fileUrlApsap = self.detailsCotisations[0].FileUrlApsap;

            if (fileUrlApsap != null && fileUrlApsap != '') {
              const urlApsapArray: string[] = fileUrlApsap.split('/');

              const pdfApsap = urlApsapArray[3];
              this.loggerService.log('fileUrlApsap', fileUrlApsap);
              this.loggerService.log('pdfApsap', pdfApsap);

              if (pdfApsap.includes('APSAP')) {
                self.statusAPSAP = " des statuts de l'APSAP";
              } else if (pdfApsap.includes('ANP')) {
                self.declaration.subDeclarations[0].content =
                  " <strong>Accepter d'adhérer à l'ANP</strong> (Association Nationale de Prévoyance)";
                self.statusAPSAP = " des statuts de l'ANP";
              } else if (pdfApsap.includes('ANASAP')) {
                self.declaration.subDeclarations[0].content =
                  " <strong>Accepter d'adhérer à l'ANASAP</strong> (ASSOCIATION NOUVELLE D'ASSURANCE SANTE PREVOYANCE)";
                self.statusAPSAP = " des statuts de l'ANASAP";
              }
            } else {
              self.declaration.subDeclarations =
                self.declaration.subDeclarations.slice(1); //Enlever le 1er element de la déclaration s'il n'y a pas d'url apsap
              self.statusAPSAP = '';
            }
          } else {
            this.loggerService.log(
              'Erreur lors de la récupérations des frais de cotisations!',
            );
          }
        },
        error: (error) => {
          this.loggerService.log('Erreur GetDetailsCotisation : ' + error);
        },
      });
  }
}
